import { render } from "./Services.vue?vue&type=template&id=19f9aef1&scoped=true"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"

import "./Services.vue?vue&type=style&index=0&id=19f9aef1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-19f9aef1"

export default script